import script from "./OrganismsChartSaltos.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganismsChartSaltos.vue?vue&type=script&lang=ts&setup=true"

import "./OrganismsChartSaltos.vue?vue&type=style&index=0&id=7590b29a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7590b29a"]])

export default __exports__